import { forwardRef, useEffect, useRef } from "react";
import Quill from "quill";

const QuillEditor = forwardRef(
  ({ defaultValue, className, toolbarOptions, boldIcon, italic, header3, header1, link, readOnly }, ref) => {
    const containerRef = useRef(null);
    const defaultValueRef = useRef(defaultValue);

    useEffect(() => {
      const container = containerRef.current;
      const editorContainer = container.appendChild(
        container.ownerDocument.createElement("article"),
      );

      //custom icons
      const icons = Quill.import('ui/icons');
      if (boldIcon) {
        icons['bold'] = `<div class="ql-boldIconContainer"><img src="${boldIcon}" alt="bold" /></div>`;
      }
      if (italic) {
        icons['italic'] = `<div class="ql-italicIconContainer"><img src="${italic}" alt="italic" /></div>`;
      }
      if (header1) {
        icons.header = icons.header || {};
        icons.header['1'] = `<div class="ql-h1IconContainer"><img src="${header1}" alt="header1" /></div>`;
      }
      if (header3) {
        icons.header = icons.header || {};
        icons.header['3'] = `<div class="ql-h3IconContainer"><img src="${header3}" alt="header3" /></div>`;
      }
      if (link) {
        icons['link'] = `<div class="ql-linkIconContainer"><img src="${link}" alt="link" /></div>`;
      }

      const quill = new Quill(editorContainer, {
        theme: "snow",
        readOnly: readOnly,
        modules: {
          toolbar: readOnly ? false : toolbarOptions
        }
      });

      ref.current = quill;

      //set default text value of the quill
      if (defaultValueRef.current) {
        quill.setContents(defaultValueRef.current);
      }

      return () => {
        ref.current = null;
        container.innerHTML = "";
      };
    }, [ref]);

    return <section className={className} ref={containerRef}></section>;
  },
);

QuillEditor.displayName = "Editor";

export default QuillEditor;